import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useTable, useRowSelect, usePagination, useSortBy } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEllipsisH,
  faCalendarAlt,
  faRefresh,
  faEdit,
  faCheck,
  faXmark,
  faFilter,
  faFileExport,
  faDownload,
  faTrashAlt,
  faAdd,
  faHotTub,
  faPlusMinus,
  faExchangeAlt,
  faPlay,
  faStop,
  faMinus,
  faAngleLeft,
  faAngleRight,
  faTrash,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  ButtonGroup,
  Input,
  Form,
  Popover,
  PopoverBody,
} from "reactstrap";
import "./DataTable.scss";
import ModalComponent from "../modal/ModalComponent";
import AddData from "../../views/project/data/add_data/AddData";
import Loader from "../Loader";
import VersionDetail from "../../views/project/data/version_detail/VersionDetail";
import ErrorScreen from "../error/ErrorScreen";
import useFetch from "../useFetch";
import Confirm from "../confirm/Confirm";
import { ReactStrapModal } from "../reactstrap_modal/ReactStrapModal";
import getDataFromApi from "../getDataFromApi";
import Export from "../../views/project/data/add_data/Export";
import ModifyOperations from "../../views/project/data/add_data/ModifyOperations";
import AddtoHub from "../../views/project/data/add_data/AddtoHub";
import Modals_Compare from "../../views/project/models/Modals_Compare";
import { StyledTooltip } from "../../views/project/label/annotation/EditorView/EditorTopNavigationBar/EditorTopNavigationBar";
import { getCokkie } from "../../views/login/Login";

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    );
  }
);
var modalClass = "";

// Create an editable cell renderer
const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData, // This is a custom function that we supplied to our table instance
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState();
  const [edit, setEdit] = React.useState(false);
  const onChange = (e) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onSubmit = (e) => {
    e.preventDefault();
    const url = `${window["ENV"].API_URL}/dataset_versions/${data.data[index].Id}/description?msg=${value}`;
    getDataFromApi(url, "put")
      .then((res) => (res.ok ? updateMyData(index, id, value) : null))
      .catch((e) => console.log(e));
    setEdit(!edit);
  };

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  if (id === "description")
    return (
      <Form style={{ position: "relative" }}>
        <Input
          wrap="soft"
          maxLength={50}
          title={value}
          type="textarea"
          className={!edit ? "input_no_border table_input" : "table_input"}
          readOnly={!edit}
          value={value ?? "-"}
          onChange={onChange}
          onKeyDownCapture={(e) => e.code === "Enter" && onSubmit(e)}
        />
        {!edit && (
          <span
            style={{ position: "absolute", left: 215, top: "14px" }}
            onClick={(e) => setEdit(!edit)}
          >
            {" "}
            <FontAwesomeIcon icon={faEdit} />
          </span>
        )}
      </Form>
    );
  else return <>{value}</>;
};

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
  Cell: EditableCell,
};

export function Table({
  columns,
  data,
  architecture,
  datasetId,
  updateMyData,
  setFormPath,
  format,
  onRowSelectionChange,
  model_name,
  model_comp,
  rows,
  layerdata
}) {
  var initialState = { hiddenColumns: ["Id", "eval_id"] };
  const [selectedRows, setSelectedRows] = useState([]);
  const [Id, setId] = useState();
  const [Component, setComponent] = useState();
  const [datasetDeleteUrl, setDatasetDeleteUrl] = useState();
  const [pageLoading, setPageLoading] = useState(false);

  const buttonRef = useRef(null);
  useEffect(() => {
    setSelectedRows([]);
  }, [architecture]);

  const handleRowSelection = (event, row) => {
    const { checked } = event.target;

    setSelectedRows((prevSelectedRows) => {
      let updatedSelectedRows = [...prevSelectedRows];

      if (checked) {
        updatedSelectedRows.push(row.original.Id);
      } else {
        updatedSelectedRows = updatedSelectedRows.filter(
          (id) => id !== row.original.Id
        );
      }

      onRowSelectionChange(updatedSelectedRows);
      return updatedSelectedRows;
    });
  };

  const handleDownload = async (id, actionType) => {

    try {
      const payload = {
        _id: id,
        action: actionType.toLowerCase(),
      };

      const token = getCokkie("jwtToken");
      const url = `${window.ENV.API_URL}/evaluations/action?visual_inspection=false`;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      console.log("Action result:", result);

      // Automatically trigger download if the action is 'Download'
      if (actionType.toLowerCase() === "download" && result) {
        const downloadLink = document.createElement("a");
        downloadLink.href = result;
        downloadLink.download = ""; // let the browser decide filename
        downloadLink.target = "_blank"; // open in new tab if needed
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      console.error("Error performing action:", error);
    }
  };

  if (datasetId) {
    columns[0].Cell = (e) => (
      <div
        className="text-primary cursor-pointer fw-bold"
        onClick={() => {
          if (e.value === "0.0.0") return;
          modalClass = " modal-90";
          setComponent(<VersionDetail id={e.cell.row.original.Id} />);
          setId(e.cell.row.original.Id);
        }}
      >
        {e.value}
      </div>
    );
  }




  if (model_name) {
    columns[1].Cell = (e) => {
      const mainText = e.value?.replace(/\s*\(.*?\)/, ''); // remove the part in parentheses
      const subTextMatch = e.value?.match(/\((.*?)\)/); // extract the part in parentheses
      const subText = subTextMatch ? subTextMatch[1] : null;

      return (
        <div className="text-center fw-bold">
          {/* <div>{mainText}</div> */}
          {subText && <div className="text-secondary text-uppercase" style={{ fontSize: '0.85em' }}>{subText}</div>}
        </div>
      );
    };
    columns[3].Cell = (e) => (
      <div
        className={`${e.value === "evaluating" ? "text-warning" : e.value === "Evaluating" ? "text-warning" : e.value === "queued" ? "text-info" : e.value === "Queued" ? "text-info" : e.value === "starting" ? "text-primary" : e.value === "Starting" ? "text-primary" : e.value === "Complete" ? "text-success" : e.value === "failed" ? "text-danger" : e.value === "Failed" ? "text-danger" : e.value === "Converting" ? "text-primary-emphasis" : " "} text-capitalize  fw-bold`}
      >
        {e.value}
      </div>
    );




    const downloadCol = columns.find((col) => col.id === "download");
    if (downloadCol) {
      downloadCol.Header = "Download";
      downloadCol.Cell = (e) => {
        const { status, eval_id } = e.row.original;
        const disabled = status !== "Complete";

        return !disabled ? (
          <span
            className="text-primary fw-bold"
            style={{ cursor: "pointer" }}
            onClick={() => handleDownload(eval_id, "download")}
          >
            <FontAwesomeIcon icon={faDownload} />
          </span>
        ) : (
          <span className="text-secondary">-</span>
        );
      };
    }

  }


  if (model_comp && columns.length > 0) {
    // console.log('colums', columns)
    columns[2].Cell = (e) => (
      <div>
        {(e.value === 'yes' && <FontAwesomeIcon className="text-primary" icon={faCheck} />) || (e.value === 'no' && <FontAwesomeIcon className="text-danger" icon={faXmark} />) || (e.value === '-' && <FontAwesomeIcon className="mutted-text" icon={faMinus} />)}
      </div>
    );
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      defaultColumn,
      data,
      initialState,
      updateMyData,
      autoResetPage: false,
    },
    useSortBy,
    usePagination,
    useRowSelect,

  );


  useEffect(() => {
    if (pageIndex === 0) return;
    // do nothing on pagination updates
  }, [data]);
  

  useEffect(() => {
    setPageLoading(false);
  }, [pageIndex, data]);


  useEffect(() => {
    if (rows != null && rows !== pageSize) {
      setPageSize(rows);
    }
  }, [rows, pageSize, setPageSize]);

  // Render the UI for your table
  return (
    <>
      {/* <pre>
        <code>
          {JSON.stringify(
            {
              pageIndex,
              pageSize,
              pageCount,
              canNextPage,
              canPreviousPage,
            },
            null,
            2
          )}
        </code>
      </pre> */}
      <table className="custom_table1 grey-card-table-border" {...getTableProps()} style={{ borderRadius: '20px' }}>
        <thead className="grey-card-table grey-card-table-border tr-head ">
          {headerGroups.map((headerGroup) => (
            <tr className="table_head table_head1" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={`table-cell py-4 table_head1 text-center 
                  ${layerdata ? "layerdata-col"
                      :
                      column.Header === "Status" ? "status-col"
                        :
                        column.Header === "TPS" ? "tps-col"
                          :
                          column.Header === "Layer Name" ? "layername-col"
                            :
                            column.Header === "Download" ? "status-col" : ""
                    }`}

                >
                  {column.render("Header")}
                  {
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  }
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="tr-hovered2">
                {row.cells.map((cell, index) => {
                  const isMetricColumn = index === 6 && cell.column.Header === "Metric"; // Check for the 7th column
                  return (
                    <td {...cell.getCellProps()}
                      className={`text-center table-cell ps-4 ${cell.column.Header === "Status" ? "status-col" :
                        cell.column.Header === "TPS" ? "tps-col"
                          :
                          cell.column.Header === "Layer Name" ? "layername-col" : ""
                        }`}

                    >
                      {isMetricColumn ? (
                        <div style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                          {cell.value !== "NA" ? (
                            <div title={cell.value}>
                              <div
                                style={{
                                  height: "10px",
                                  width: "80px", // Total width of the progress bar
                                  backgroundColor: "#e0e0e0", // Light grey background
                                  borderRadius: "5px",
                                  overflow: "hidden",
                                  marginRight: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "100%",
                                    width: `${isNaN(parseFloat(cell.value)) ? 0 : parseFloat(cell.value)}%`, // Default to 0 if not a number
                                    backgroundColor:
                                      !isNaN(parseFloat(cell.value)) && parseFloat(cell.value) > 99
                                        ? "green" // Green for >99%
                                        : "#1a73e8", // Blue otherwise
                                    transition: "width 0.3s ease", // Smooth transition
                                  }}
                                ></div>
                              </div>
                              <span>{isNaN(parseFloat(cell.value)) ? "0" : parseFloat(cell.value)}%</span>
                              {/* Display percentage as text */}
                            </div>
                          ) : (
                            <span>{cell.value}</span> // Fallback for "NA"
                          )}
                        </div>
                      ) : layerdata ? (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={cell.value}
                        >
                          {cell.render("Cell")}
                        </div>
                      )
                        : (
                          <div title={cell.value}>
                            {cell.value === null ? "-" : cell.render("Cell")}
                          </div>
                        )

                      }
                    </td>
                  );
                })}
                {datasetId && (
                  <td style={{ paddingRight: 0, position: "relative" }}>
                    <UncontrolledDropdown
                      className="cursor-pointer"
                      style={{
                        position: "absolute",
                        right: "-22px",
                        top: 24,
                      }}
                    >
                      <DropdownToggle icon="true" className="fw-bold">
                        <FontAwesomeIcon
                          icon={faEllipsisH}
                          size="lg"
                          color=""
                        />
                      </DropdownToggle>
                      <DropdownMenu end>
                        <DropdownItem
                          onClick={() => {
                            modalClass = "";
                            setComponent(
                              <Export
                                datasetId={row.original.Id}
                                close={setId}
                              />
                            );
                            setId("modalIsOpen");
                          }}
                        // onClick={e => setFormPath(
                        //   // `forms/export/?ds_version_id=${row.original.Id}`,
                        //   `forms/export_data?ds_version_id=${row.original.Id}`
                        // )}
                        >
                          Export
                        </DropdownItem>
                        <DropdownItem
                          // onClick={() => handleDownload(row.original.Id)}
                          onClick={(e) =>
                            setFormPath(
                              // `forms/export/?ds_version_id=${row.original.Id}`,
                              `forms/download_data/${row.original.Id}`
                            )
                          }
                        >
                          Download
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            setDatasetDeleteUrl(
                              `${window["ENV"].API_URL}/dataset_versions/${row.original.Id}?confirm=`
                            )
                          }
                        >
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      {pageOptions?.length > 1 && (
        <div
          className={`d-flex justify-content-between align-items-center ${rows && 'evaluation-pagination float-end'}`}
          style={{ padding: "20px 20px 0 0" }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ gap: "10px", position: "relative", left: "21px" }}
          >
            <FontAwesomeIcon
              icon={pageLoading ? faSpinner : faAngleLeft}
              spin={pageLoading}
              onClick={() => {
                if (!canPreviousPage || pageLoading) return;
                setPageLoading(true);
                previousPage();
              }}
              style={{
                cursor: !canPreviousPage ? "not-allowed" : "pointer",
                opacity: !canPreviousPage ? 0.5 : 1
              }}
            />

            <div>
              <strong style={{ fontWeight: "500" }}>
                {pageIndex + 1} {""}
                / {pageOptions.length}
              </strong>{" "}
            </div>
            <FontAwesomeIcon
  icon={pageLoading ? faSpinner : faAngleRight}
  spin={pageLoading}
  onClick={() => {
    if (!canNextPage || pageLoading) return;
    setPageLoading(true);
    nextPage();
  }}
  style={{
    cursor: !canNextPage ? "not-allowed" : "pointer",
    opacity: !canNextPage ? 0.5 : 1
  }}
/>

          </div>
          {/* <div>
            Go to page:{" "}
            <input
              className="d-inline form-control-sm"
              min={1}
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "100px" }}
            />
          </div>{" "} */}
          {/* <div>
            Rows per page :{" "}
            <input
              type="number"
              min={1}
              className="input-spin data-arrow"
              defaultValue={pageSize}
              style={{
                border: "none",
                outline: "none",
                width: `${pageSize.toString().length * 13}px`,
              }}
              onChange={(e) => {
                setPageSize(Number(e.target.value < 1 ? "1" : e.target.value));
              }}
            />
          </div> */}
        </div>
      )}
      {/* <> 
        <pre>
          <code>
            {JSON.stringify(
              {
                selectedRowIds: selectedRowIds,
                "selectedFlatRows[].original": selectedFlatRows.map(
                  (d) => d.original
                ),
              },
              null,
              2
            )}
          </code>
        </pre>
      </> */}

      <ModalComponent
        modalIsOpen={Id}
        setModalIsOpen={setId}
        modalClass={"p-3" + modalClass}
        component={Component}
      />
      {datasetDeleteUrl && (
        <Confirm url={datasetDeleteUrl} close={() => setDatasetDeleteUrl()} />
      )}
    </>
  );
}

function Filter({ data, setData, datasetId, refetch, setFormPath }) {
  const [component, setComponent] = useState();
  const [id, setId] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedUsers, setSelectedusers] = useState();
  React.useEffect(() => {
    if (!data) return;
    const columns = data.columns;
    let row =
      selectedUsers?.length > 0
        ? data.data.filter((item) => selectedUsers.includes(item.createdBy))
        : data.data;
    if ((selectedDate !== undefined) & (selectedDate !== "")) {
      let t = new Date();
      const newDate = new Date(
        Date.UTC(t.getFullYear(), t.getMonth(), t.getDate() - selectedDate)
      );
      row = row.filter((item) => new Date(item.createdOn) >= newDate);
    }
    setData({ columns, data: row });
  }, [selectedUsers, selectedDate, data, setData]);

  return (
    <>
      <div className="table-filter">
        <UncontrolledDropdown className="grey-text">
          {/* <FontAwesomeIcon
            icon={faFilter}
            size="lg"
            className="me-2"
          /> */}
          <Select
            isMulti
            name="users"
            options={uniqueUsers}
            className=""
            classNamePrefix="select"
            placeholder="Filter by users"
            onChange={(e) => setSelectedusers(e.map((v) => v.value))}
            styles={{
              control: (provided) => ({
                ...provided,
                border: "transparent",
                background: "transparent",
                fontSize: "12px",
              }),
            }}
          />
        </UncontrolledDropdown>
        <UncontrolledDropdown className="grey-text">
          {/* <FontAwesomeIcon
            icon={faCalendarAlt}
            size="lg"
            color="#3755d3"
            className="me-2"
          />{" "} */}
          <Select
            // defaultValue={[colourOptions[], colourOptions[3]]}

            name="Days"
            options={[
              { label: "All Days", value: "" },
              { label: "Last 30 Days", value: "30" },
              { label: "Last 15 Days", value: "15" },
              { label: "Last 7 Days", value: "7" },
            ]}
            className="basic-multi-select px-1"
            placeholder="Filter by Days"
            onChange={(e) => setSelectedDate(e.value)}
            styles={{
              control: (provided) => ({
                ...provided,
                border: "transparent",
                background: "transparent",
                fontSize: "12px",
                fontWeight: "500",
              }),
            }}
          />
          {/* <FontAwesomeIcon icon={faCalendarAlt} size='md' /> */}
        </UncontrolledDropdown>

        <span
          style={{ width: "1px", background: "gray", margin: "0px 8px" }}
        ></span>

        {/* <DropdownItem onClick={function noRefCheck() {}}> */}
        <StyledTooltip title="Add to Hub">
          <FontAwesomeIcon
            icon={faHotTub}
            className="mt-3 ms-4 button-icon"
            style={{ color: "gray" }}
            onClick={() => {
              modalClass = "";
              setComponent(<AddtoHub datasetId={datasetId} close={setId} />);
              setId("modalIsOpen");
            }}
          />
        </StyledTooltip>
        <StyledTooltip title="Add More Data">
          <FontAwesomeIcon
            icon={faPlusMinus}
            className="mt-3 ms-4 button-icon"
            style={{ color: "gray" }}
            onClick={() => {
              modalClass = "";
              setComponent(<AddData datasetId={datasetId} close={setId} />);
              setId("modalIsOpen");
            }}
          />
        </StyledTooltip>
        {/* <DropdownItem
                onClick={() => {
                  modalClass = "";
                  setId("modalIsOpen");
                  setComponent(
                    <GenerateTaskCollection
                      datasetId={datasetId}
                      close={setId}
                    />
                  );
                }}
              >
                Generate Task collection
              </DropdownItem> */}
        <StyledTooltip title="Modify Operations">
          <FontAwesomeIcon
            icon={faExchangeAlt}
            // onClick={() => {
            //   setFormPath(
            //     `forms/data/modify_operations/${datasetId}`
            //   );
            // }}
            className="mt-3 ms-4 button-icon"
            style={{ color: "gray" }}
            onClick={() => {
              modalClass = "";
              setId("modalIsOpen");
              setComponent(
                <ModifyOperations datasetId={datasetId} close={setId} />
              );
            }}
          />
        </StyledTooltip>

        <StyledTooltip title="refetch">
          <FontAwesomeIcon
            icon={faRefresh}
            className="mt-3 ms-4 button-icon"
            style={{ color: "gray" }}
            onClick={refetch}
          />
        </StyledTooltip>

        <ModalComponent
          modalIsOpen={id}
          setModalIsOpen={setId}
          modalClass={"p-3" + modalClass}
          component={component}
        />
      </div>
    </>
  );
}

var data, uniqueUsers;
function DataTable(props) {
  const exportLocal = localStorage.getItem("export_type");
  const [Data, setData] = useState();
  const [formPath, setFormPath] = useState();
  const [initialLoad, setInitialLoad] = useState(true);

  const [model, setModel] = React.useState();
  const [Component, setComponent] = React.useState();
  const [exportType, setExportType] = useState(exportLocal ?? "coco");
  const { data: result, refetch, loading, error } = useFetch(props.url, "get");
  const [selectedNames, setSelectedNames] = useState([]);
  const handleRowSelectionChange = (selectedRows) => {
    setSelectedNames(selectedRows.map((row) => row));
  };

  useEffect(() => {
    if (!result) return;
    uniqueUsers = "";
    data = "";
    data = result;
    props.filter &&
      (uniqueUsers = [...new Set(data.data.map((item) => item.createdBy))].map(
        (v) => ({ value: v, label: v })
      ));
    setData(result);
  }, [props.filter, props.url, result]);

  useEffect(() => {
    if (result && initialLoad) {
      setInitialLoad(false);
    }
  }, [result, initialLoad]);
  

  if (loading && initialLoad) return <Loader />;

  if (error) {
    console.log(error);
  }
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    // setSkipPageReset(true);
    setData((old) => {
      return {
        columns: old.columns,
        data: old.data.map((row, index) =>
          index === rowIndex
            ? {
              ...old.data[rowIndex],
              [columnId]: value,
            }
            : row
        ),
      };
    });
  };

  if (!props?.datasetId) return <ErrorScreen message={"No Table Found"} />;
  return (
    <>
      {props.greyCard && (
        <div className="grey-card-table">
          <div className="p-4">
            {props.versionTree && (
              <ButtonGroup>
                <Button color="primary" onClick={function noRefCheck() { }}>
                  Version table
                </Button>
                {/* <Button
                  outline
                  disabled
                  color="secondary"
                  onClick={function noRefCheck() { }}
                >
                  Version tree
                </Button> */}
              </ButtonGroup>
            )}
            &nbsp;
            <StyledTooltip
              title={
                (selectedNames.length > 2 &&
                  "Select only two versions to compare") ||
                (selectedNames.length < 2 &&
                  "Select two versions to compare") ||
                (selectedNames.length == 2 && "Compare")
              }
            >
              <span>
                <Button
                  color="success"
                  onClick={() => {
                    setModel("modelIsOpen");
                    setComponent(
                      <Modals_Compare
                        close={setModel}
                        _selectedNames={selectedNames}
                      />
                    );
                  }}
                  disabled={selectedNames.length == 2 ? false : true}
                >
                  Compare
                </Button>
              </span>
            </StyledTooltip>
            {props.filter && (
              <Filter
                data={data}
                Data={Data}
                setData={setData}
                datasetId={props.datasetId}
                refetch={refetch}
                setFormPath={setFormPath}
              />
            )}
          </div>
        </div>
      )}
      {Data?.data ? (
        <>
          <div className="table-default w-100">
            <Table
              columns={Data.columns}
              data={Data.data}
              dataset
              tableActionButton={props.tableActionButton}
              architecture={props.architecture}
              datasetId={props.datasetId}
              updateMyData={updateMyData}
              setFormPath={setFormPath}
              format={exportType}
              onRowSelectionChange={handleRowSelectionChange}
            />
          </div>
        </>
      ) : (
        <ErrorScreen message={"No Table to Display"} />
      )}

      <ModalComponent
        modalIsOpen={model}
        setModalIsOpen={setModel}
        modalClass={"bg-white p-3 modal-90"}
        component={Component}
      />
      <ReactStrapModal
        open={formPath?.length > 0}
        close={() => setFormPath()}
        path={formPath}
        onSubmit={(formData, result) => {
          localStorage.setItem("export_type", formData?.["Export Type"]);
          setExportType(formData?.["Export Type"]);
        }}
      />
    </>
  );
}
export default DataTable;
